import type { DuplicateGiftLink } from '../api/client'

export type GiftRole = 'giver' | 'receiver' | 'both'

/** Whether this account gave, received, or both, across the pair's gift links. */
export function giftRole(links: DuplicateGiftLink[] | undefined, subId: number | undefined): GiftRole | null {
  if (!links?.length || subId === undefined) return null
  const gave = links.some((l) => l.giver_id === subId)
  const got = links.some((l) => l.receiver_id === subId)
  return gave && got ? 'both' : gave ? 'giver' : got ? 'receiver' : null
}
